
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1Xeln", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("keyLG")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $keyLG = parcelRequire("keyLG");

});
parcelRegister("keyLG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7fdd3fbee96fc7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $7CMCs = parcelRequire("7CMCs");

var $g0Gtc = parcelRequire("g0Gtc");

var $2i4sA = parcelRequire("2i4sA");

var $x9xyg = parcelRequire("x9xyg");

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $1fyfD = parcelRequire("1fyfD");

var $d31Su = parcelRequire("d31Su");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");

var $38Y30 = parcelRequire("38Y30");

var $4dRjY = parcelRequire("4dRjY");

var $9OXo1 = parcelRequire("9OXo1");

var $l8ruj = parcelRequire("l8ruj");

var $bmKPg = parcelRequire("bmKPg");

var $j8DrX = parcelRequire("j8DrX");


var $ahuix = parcelRequire("ahuix");

var $8wh20 = parcelRequire("8wh20");
const $bd7fdd3fbee96fc7$export$2532845c810cfaa1 = ()=>{
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$df49868e6ee293e));
    });
    const [boardIdStr] = (0, $bmKPg.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const isCompanyManaged = (0, $ahuix.useIsCMPBacklogRoute)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isAuthenticated = (0, $9NiTW.checkAuthentication)(tenantContext);
    const hasSoftwareLicense = (0, $3RV1W.checkLicense)(tenantContext, 'software');
    const isEmbedView = (0, $1fyfD.useIsEmbedView)();
    if (!isAuthenticated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experienceId: `${boardId}`,
        experience: "viewBacklog",
        analyticsSource: "backlog",
        edition: tenantContext.appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE),
        additionalAttributes: {
            isClassic: isCompanyManaged,
            isUIF: true,
            jswSprintPlanningWhiteboards: (0, $4R6GH.fg)('sprint_planning_whiteboards_kill_switch'),
            shard: (0, $j8DrX.default)('ajs-shard') ?? {},
            region: (0, $j8DrX.default)('ajs-region') ?? {},
            ...typeof isEmbedView === 'boolean' ? {
                isEmbed: isEmbedView
            } : {}
        }
    }, hasSoftwareLicense ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wh20.default), {
        isCompanyManaged: isCompanyManaged
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: "ng-backlog-context-query"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d31Su.AsyncNoSoftwareLicense), null)));
};
const $bd7fdd3fbee96fc7$var$BacklogWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "backlog-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "spa-app-bootstrap.next-gen.backlog",
        fallback: "flag",
        packageName: (0, $a64d16806d35fb92$export$b8b9d90f9e5bd72b),
        teamName: (0, $a64d16806d35fb92$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd7fdd3fbee96fc7$export$2532845c810cfaa1, null)));
var $bd7fdd3fbee96fc7$export$2e2bcd8739ae039 = $bd7fdd3fbee96fc7$var$BacklogWrapper;

});
parcelRegister("1fyfD", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedView", () => $a4ef6d470ff8a97a$export$83ee417ebec96ced);

var $iGbXw = parcelRequire("iGbXw");

var $78yv1 = parcelRequire("78yv1");

var $doZTA = parcelRequire("doZTA");
const $a4ef6d470ff8a97a$export$83ee417ebec96ced = ()=>{
    const [{ route: route }] = (0, $doZTA.useRouter)();
    return route.name === (0, $78yv1.softwareBacklogEmbedRoute).name || route.name === (0, $iGbXw.classicSoftwareBacklogEmbedRoute).name;
};

});
parcelRegister("iGbXw", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogEmbedRoute", () => $100ce1fd940d8aba$export$e6776ef8123b7136);
const $100ce1fd940d8aba$export$e6776ef8123b7136 = {
    name: 'rapidboard-backlog-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
};

});

parcelRegister("78yv1", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogEmbedRoute", () => $58a7d1c6d58c26bf$export$bc022a39c42aba2f);
const $58a7d1c6d58c26bf$export$bc022a39c42aba2f = {
    name: 'software-backlog-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
    exact: true
};

});


parcelRegister("d31Su", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $dcd2c1aef082694d$export$52d8964299339cae);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $dcd2c1aef082694d$var$LazyNoSoftwareLicense = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3jLGc")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $dcd2c1aef082694d$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcd2c1aef082694d$var$LazyNoSoftwareLicense, null));

});
parcelRegister("3jLGc", function(module, exports) {

let $26a8219ae6acc109$var$load = (parcelRequire("28QjX"))(4);
module.exports = $26a8219ae6acc109$var$load("1EEDl").then(()=>parcelRequire('eX102'));

});


parcelRegister("9NiTW", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $ad297a7f2ce81084$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $ad297a7f2ce81084$export$e9b9096e887386fe);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $38Y30 = parcelRequire("38Y30");
const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    });

});
parcelRegister("38Y30", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $08f8c3f776d557a9$export$938182bd3fddc3a8);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $doZTA.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $ieDtd.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: path
    });
};

});


parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $a64d16806d35fb92$export$b5f697f1279a473e = 'USE_RESOURCE_START';
const $a64d16806d35fb92$export$a6940922387b16 = 'USE_RESOURCE_READY';
const $a64d16806d35fb92$export$e9163c48bfd4013e = 'BACKLOG_PREFETCHED_DATA_READY';
const $a64d16806d35fb92$export$df49868e6ee293e = 'BACKLOG_ROOT_SPA_APP_START';
const $a64d16806d35fb92$export$dedbdcc35e955187 = 'BACKLOG';
const $a64d16806d35fb92$export$e927a5d1b72f0b68 = 'ENABLED';
const $a64d16806d35fb92$export$8cd212c10b4124d2 = 'DISABLED';
const $a64d16806d35fb92$export$912d9029af46d426 = 'Board is locationless';
const $a64d16806d35fb92$export$b8b9d90f9e5bd72b = '@atlassian/jira-spa-apps-next-gen-backlog';
const $a64d16806d35fb92$export$d57b6b390e78d90f = 'A4T-Tanuki';

parcelRegister("ahuix", function(module, exports) {

$parcel$export(module.exports, "getBoardUrl", () => $4f74b523b1495014$export$505a9f131607d070);
$parcel$export(module.exports, "getCMPBoardUrl", () => $4f74b523b1495014$export$c89a0c88af322ce1);
$parcel$export(module.exports, "isBacklogDisabled", () => $4f74b523b1495014$export$c5cfccba3ef0f2a9);
$parcel$export(module.exports, "useOnce", () => $4f74b523b1495014$export$392544347a18b6ea);
$parcel$export(module.exports, "useIsCMPBacklogRoute", () => $4f74b523b1495014$export$d2d03c28ed220603);

var $5uXOq = parcelRequire("5uXOq");

var $dXq4S = parcelRequire("dXq4S");

var $6jY6G = parcelRequire("6jY6G");

const $4f74b523b1495014$export$505a9f131607d070 = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/boards/${boardId}`;
const $4f74b523b1495014$export$c89a0c88af322ce1 = (projectKey, boardId)=>`/jira/software/c/projects/${projectKey}/boards/${boardId}`;
const $4f74b523b1495014$export$c5cfccba3ef0f2a9 = (data)=>{
    if (!data?.boardScope.features) return false;
    return data.boardScope.features.some(({ key: key, status: status })=>key === (0, $a64d16806d35fb92$export$dedbdcc35e955187) && status === (0, $a64d16806d35fb92$export$8cd212c10b4124d2));
};
const $4f74b523b1495014$var$defaultPredicate = ()=>true;
const $4f74b523b1495014$export$392544347a18b6ea = (callback, predicate = $4f74b523b1495014$var$defaultPredicate)=>{
    const done = (0, $5uXOq.useRef)(false);
    if (!done.current && predicate()) {
        callback();
        done.current = true;
    }
};
const $4f74b523b1495014$export$79640a85913af5aa = (ari)=>{
    const possibleAri = (0, $dXq4S.toAri)(ari);
    if (possibleAri) return (0, $dXq4S.getAriConfig)(possibleAri).resourceId;
    return ari;
};
const $4f74b523b1495014$export$d2d03c28ed220603 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    return [
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-backlog-embed'
    ].includes(route.name);
};

});

parcelRegister("8wh20", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9eecd2d577f994b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jVPfn = parcelRequire("jVPfn");

var $bcP1m = parcelRequire("bcP1m");
const $e9eecd2d577f994b$var$BacklogMetaAPIConsumerWrapper = ({ isCompanyManaged: isCompanyManaged })=>{
    if (isCompanyManaged) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVPfn.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcP1m.default), null);
};
var $e9eecd2d577f994b$export$2e2bcd8739ae039 = $e9eecd2d577f994b$var$BacklogMetaAPIConsumerWrapper;

});
parcelRegister("jVPfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b62083da6b4fd29f$export$2e2bcd8739ae039);
parcelRequire("3avtZ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $x9xyg = parcelRequire("x9xyg");

var $cSD7y = parcelRequire("cSD7y");

var $ezRTW = parcelRequire("ezRTW");

var $dXq4S = parcelRequire("dXq4S");

var $3mYHL = parcelRequire("3mYHL");

var $ao2h1 = parcelRequire("ao2h1");

var $jgtyX = parcelRequire("jgtyX");

var $9SRRO = parcelRequire("9SRRO");

var $5Nutl = parcelRequire("5Nutl");

var $5uWNE = parcelRequire("5uWNE");

var $9dbF6 = parcelRequire("9dbF6");

var $gqLmL = parcelRequire("gqLmL");

var $9OXo1 = parcelRequire("9OXo1");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");
var $2YP9W = parcelRequire("2YP9W");

var $0z6W8 = parcelRequire("0z6W8");


var $ahuix = parcelRequire("ahuix");

var $1kij3 = parcelRequire("1kij3");
const $b62083da6b4fd29f$export$ad5cd5a1ff804acc = ()=>{
    const [paramProjectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const [boardIdStr] = (0, $bmKPg.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const projectKey = paramProjectKey ?? '';
    const tenantContext = (0, $9OXo1.useTenantContext)();
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$b5f697f1279a473e));
    });
    const jiraPlanDataRestResource = (0, $2YP9W.useResource)((0, $5Nutl.uifBacklogResourceOld));
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$a6940922387b16));
    });
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$e9163c48bfd4013e));
    }, ()=>!!jiraPlanDataRestResource.data);
    const response = (0, $ao2h1.useRelayResource)((0, $9SRRO.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const isCacheHitRef = (0, $5uXOq.useRef)(jiraPlanDataRestResource.data != null);
    const isCacheHit = isCacheHitRef.current;
    const { data: data, promise: promise, loading: loading, error: error } = jiraPlanDataRestResource;
    const { data: features } = (0, $ezRTW.useFeatures)();
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $8Uumt.useQueryLoader)((0, $jgtyX.default));
    (0, $5uXOq.useEffect)(()=>{
        if (loadVersionFilterRelayQuery !== null && data?.projects?.length) {
            const jiraProjectIds = data.projects.map((project)=>(0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'project',
                    resourceId: `${project.id}`
                }));
            loadVersionFilterRelayQuery({
                jiraProjectIds: jiraProjectIds,
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        tenantContext.cloudId,
        data?.projects
    ]);
    const [selectedIssue] = (0, $ieDtd.useQueryParam)('selectedIssue');
    (0, $5uXOq.useEffect)(()=>{
        if (selectedIssue) (0, $0z6W8.updatePageloadName)('classic-backlog-with-issue-view');
    }, [
        selectedIssue
    ]);
    /**
   * Redirect to the board only if the backlog is disabled. Do not redirect on timeout.
   *
   * If features.hasBacklog is undefined but the resource has returned a 404 due to
   * the backlog being disabled, this error will be passed through to responseToSla in
   * the BacklogApp which will redirect to the projects page as a fallback.
   *
   * */ if (loading === false && features?.hasBacklog === false) {
        const boardUrl = (0, $ahuix.getCMPBoardUrl)(projectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: boardUrl
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqLmL.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kij3.default), {
        rapidViewId: boardId,
        projectKeyFromContext: projectKey,
        projectIdFromContext: "",
        tenantContext: tenantContext,
        data: null,
        planModeData: data,
        planModeDataPromise: promise,
        error: error,
        loading: loading,
        isCacheHit: isCacheHit,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uWNE.default), {
        resource: jiraPlanDataRestResource,
        refreshOnExpired: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
        projectKey: projectKey
    }));
};
const $b62083da6b4fd29f$export$dff34c560328b03c = ()=>{
    const [paramProjectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const [boardIdStr] = (0, $bmKPg.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const projectKey = paramProjectKey ?? '';
    const tenantContext = (0, $9OXo1.useTenantContext)();
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$b5f697f1279a473e));
    });
    const uifBacklogDataResult = (0, $2YP9W.useResource)((0, $5Nutl.uifBacklogResource));
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$a6940922387b16));
    });
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$e9163c48bfd4013e));
    }, ()=>!!uifBacklogDataResult.data);
    const response = (0, $ao2h1.useRelayResource)((0, $9SRRO.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const isCacheHitRef = (0, $5uXOq.useRef)(Boolean(uifBacklogDataResult.data?.isCacheHit));
    const isCacheHit = isCacheHitRef.current;
    const { data: data, promise: promise, loading: loading, error: error } = uifBacklogDataResult;
    const { data: features } = (0, $ezRTW.useFeatures)();
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $8Uumt.useQueryLoader)((0, $jgtyX.default));
    (0, $5uXOq.useEffect)(()=>{
        if (loadVersionFilterRelayQuery !== null && data?.result?.projects?.length) {
            const jiraProjectIds = data.result.projects.map((project)=>(0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'project',
                    resourceId: `${project.id}`
                }));
            loadVersionFilterRelayQuery({
                jiraProjectIds: jiraProjectIds,
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        tenantContext.cloudId,
        data?.result?.projects
    ]);
    /**
   * Redirect to the board only if the backlog is disabled. Do not redirect on timeout.
   *
   * If features.hasBacklog is undefined but the resource has returned a 404 due to
   * the backlog being disabled, this error will be passed through to responseToSla in
   * the BacklogApp which will redirect to the projects page as a fallback.
   *
   * */ if (loading === false && features?.hasBacklog === false) {
        const boardUrl = (0, $ahuix.getCMPBoardUrl)(projectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: boardUrl
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqLmL.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kij3.default), {
        rapidViewId: boardId,
        projectKeyFromContext: projectKey,
        projectIdFromContext: "",
        tenantContext: tenantContext,
        data: null,
        cmpBacklogData: data,
        cmpBacklogDataPromise: promise,
        error: error,
        loading: loading,
        isCacheHit: isCacheHit,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uWNE.default), {
        resource: uifBacklogDataResult,
        refreshOnExpired: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
        projectKey: projectKey
    }));
};
var $b62083da6b4fd29f$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('indexeddb_cache_for_backlog', $b62083da6b4fd29f$export$dff34c560328b03c, $b62083da6b4fd29f$export$ad5cd5a1ff804acc);

});
parcelRegister("ezRTW", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $0396841ba6adfb11$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $hRzej = parcelRequire("hRzej");
const $0396841ba6adfb11$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $hRzej.extractData)(data), [
        data
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("hRzej", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $ec1c13e67ecdf44f$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $ec1c13e67ecdf44f$export$9df5fa0a366163d2 = (data)=>{
    const { aiInfo: aiInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCalendar: hasCalendar, hasCode: hasCode, hasComponents: hasComponents, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasForms: hasForms, hasGoals: hasGoals, hasIncidents: hasIncidents, hasIssues: hasIssues, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasReports: hasReports, hasRequests: hasRequests, hasRoadmap: hasRoadmap, hasSecurity: hasSecurity, hasSummaryPage: hasSummaryPage, permissionInfo: permissionInfo, hasArchivedIssues: hasArchivedIssues = false } = data;
    const isProjectOrSiteAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const hasEditWorkflowPermissions = permissionInfo.projectPermissionsQueried.EDIT_WORKFLOW === true;
    const hasEditIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    const hasManageVersionsPermissions = permissionInfo.projectPermissionsQueried.MANAGE_VERSIONS === true;
    const hasSettings = (0, $4R6GH.fg)('vmc-11-manage-versions-permission') ? isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions || hasManageVersionsPermissions : isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasCalendar: hasCalendar,
        hasCode: hasCode,
        hasComponents: hasComponents,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasGoals: hasGoals,
        hasIncidents: hasIncidents,
        hasIssues: hasIssues,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasOpsgenieSchedule: hasOpsgenieSchedule,
        hasPages: hasPages,
        hasReleases: hasReleases,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasRoadmap: hasRoadmap,
        hasSecurity: hasSecurity,
        hasSettings: hasSettings,
        hasShortcutsAdd: isProjectOrSiteAdmin,
        hasSummaryPage: hasSummaryPage
    };
};

});


parcelRegister("3mYHL", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $90d8776d2c89f4bd$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $90d8776d2c89f4bd$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $90d8776d2c89f4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $7tQej = parcelRequire("7tQej");

const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        }) : null);
};
const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
    });
var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;

});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("jgtyX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d50d3b3c70ebfb2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<988f36c7e9bf3e951137674b9ef54912>>
 * @relayHash a2c0c16f16d55ac0bad51490b643bb96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 746a6e270c8326a706f412c148498b73c6a8c5cae15ff39981bc23f1aaaa72ba
const $2d50d3b3c70ebfb2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectIds"
    }, v3 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "UNRELEASED"
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "jiraProjectIds",
        "variableName": "jiraProjectIds"
    }, v5 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v11 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewBacklogVersionFilterRelayQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "versionsForProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionFilterRelay_softwareFilters"
                                                    },
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            v6 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    v7 /*: any*/ 
                                                                ]
                                                            },
                                                            v8 /*: any*/ 
                                                        ]
                                                    },
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProjects.edges"
                                        },
                                        v10 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProjects"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewBacklogVersionFilterRelayQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v12 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "filters": [
                                "jiraProjectIds",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "versionBacklogPanelRelay_versionsForProjects",
                            "kind": "LinkedHandle",
                            "name": "versionsForProjects"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "746a6e270c8326a706f412c148498b73c6a8c5cae15ff39981bc23f1aaaa72ba",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProjects"
                        ]
                    }
                ]
            },
            "name": "viewBacklogVersionFilterRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2d50d3b3c70ebfb2$var$node.hash = "816fe123d295a6d9e687adcba29002c6";
var $2d50d3b3c70ebfb2$export$2e2bcd8739ae039 = $2d50d3b3c70ebfb2$var$node;

});

parcelRegister("9SRRO", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $87093d7252240507$export$3e390340716755de);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $aYacW = parcelRequire("aYacW");

const $87093d7252240507$export$3e390340716755de = (0, $ao2h1.createRelayResource)({
    type: (0, $fe839261f35d1611$export$faa68b3df5415bcb),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $aYacW.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true,
    isBrowserOnly: true
});

});
parcelRegister("aYacW", function(module, exports) {

$parcel$export(module.exports, "default", () => $16318ecaa49178e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<066895e3c0e872466470887b4350609b>>
 * @relayHash 8bb4d5e3e502ca70e90f4e1bb2f1614f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082
const $16318ecaa49178e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
            "metadata": {},
            "name": "viewBacklogCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$16318ecaa49178e6$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
var $16318ecaa49178e6$export$2e2bcd8739ae039 = $16318ecaa49178e6$var$node;

});

const $fe839261f35d1611$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $fe839261f35d1611$export$214238a9ff4636a = 'NEXTGEN_BACKLOG_FILTER_REFINEMENT';
const $fe839261f35d1611$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';


parcelRegister("5uWNE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdde1962c5219579$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $bVDE5 = parcelRequire("bVDE5");
/**
 * Refresh the resource on mount if it's not already loading or stale, resource from prefetch will have 10s expiry time.
 */ const $fdde1962c5219579$var$RefreshResourceOnMount = ({ resource: resource, refreshOnExpired: refreshOnExpired })=>{
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    // Store these values once, we don't want the useEffect proccing more than once after mount
    const [isFullRender] = (0, $5uXOq.useState)(isInitialRender);
    const [hasCache, setHasCache] = (0, $5uXOq.useState)(false);
    const [hasRefreshed, setHasRefreshed] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (resource === null || hasRefreshed) return;
        // If we started loading set the cache miss flag to true. React-resource-router procs this
        // on page load
        if (resource.loading || refreshOnExpired && resource.expiresAt && resource.expiresAt > Date.now()) {
            setHasCache(true);
            return;
        }
        // If this is not a full render (i.e. a SPA transition)
        // And this is a cache miss (our requested resource never got set to loading true)
        if (!isFullRender && !hasCache) {
            resource.refresh();
            setHasRefreshed(true);
        }
    }, [
        hasRefreshed,
        hasCache,
        isFullRender,
        resource,
        refreshOnExpired
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $fdde1962c5219579$var$RefreshResourceOnMountWithBoundaries = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
        id: "jira-software-resource-invalidator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdde1962c5219579$var$RefreshResourceOnMount, props));
var $fdde1962c5219579$export$2e2bcd8739ae039 = $fdde1962c5219579$var$RefreshResourceOnMountWithBoundaries;

});

parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $16v4H = parcelRequire("16v4H");

var $3iTiR = parcelRequire("3iTiR");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $16v4H.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("gqLmL", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $89b567f441a32e03$export$2dc68d50d56fbbd);

var $5uXOq = parcelRequire("5uXOq");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $jgyQq = parcelRequire("jgyQq");

var $7waah = parcelRequire("7waah");

var $liUyW = parcelRequire("liUyW");
const $89b567f441a32e03$export$2dc68d50d56fbbd = ()=>{
    const [{ data: data, error: error }] = (0, $4DPZY.useContainerContext)();
    const { chartView: chartView, boardId: boardId, isBoardLocationless: isBoardLocationless, isReportsView: isReportsView, accountId: accountId } = (0, $jgyQq.useUrlState)();
    if (!data || error) return null;
    const boardName = data.scope && data.scope.name || '';
    if ((0, $gSBIZ.isUserContext)(data) && accountId) {
        const { user: user } = data;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liUyW.UserBreadcrumbs), {
            accountId: accountId,
            boardId: Number(boardId),
            boardName: boardName,
            isReportsView: isReportsView,
            profileUrl: user.profileUrl,
            userName: user.name,
            chart: chartView,
            isLocationlessBoard: isBoardLocationless
        });
    }
    if ((0, $gSBIZ.isProjectContext)(data)) {
        const { project: project } = data;
        const projectKey = project.key;
        const projectName = project.name;
        const projectId = project.id;
        const isSimplifiedProject = project.isSimplified;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7waah.ProjectBreadcrumbs), {
            baseUrl: "",
            boardId: Number(boardId),
            boardName: boardName,
            chart: chartView,
            projectKey: projectKey,
            projectName: projectName,
            projectId: projectId,
            isSimplifiedProject: isSimplifiedProject
        });
    }
    return null;
};

});
parcelRegister("gSBIZ", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $3bb86183071b9984$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $3bb86183071b9984$export$8d1083037a4a6250);
const $3bb86183071b9984$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $3bb86183071b9984$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("jgyQq", function(module, exports) {

$parcel$export(module.exports, "useUrlState", () => $1c5a5dbec5fedd96$export$6a582373474709af);

var $doZTA = parcelRequire("doZTA");

var $eZFkq = parcelRequire("eZFkq");
const $1c5a5dbec5fedd96$export$6a582373474709af = ()=>{
    const [{ query: query, route: route, match: match }] = (0, $doZTA.useRouter)();
    const { rapidView: rapidView, chart: chart, view: view, config: config, projectKey: queryProjectKey, locationless: locationless } = query;
    const { accountId: accountId } = match.params;
    const isBoardLocationless = !!locationless;
    const shouldUsePrettyUrlState = !isBoardLocationless;
    const mode = shouldUsePrettyUrlState ? (0, $eZFkq.getModeV2)(route?.name) : (0, $eZFkq.getMode)(view);
    const boardId = shouldUsePrettyUrlState ? match.params.boardId : rapidView;
    const projectKey = shouldUsePrettyUrlState ? match.params.projectKey : queryProjectKey;
    const chartView = shouldUsePrettyUrlState ? (0, $eZFkq.toCamelCaseChartView)(match.params.chartView || '') : chart;
    const isReportsView = query && query.view === 'reporting';
    return {
        accountId: accountId,
        mode: mode,
        boardId: boardId,
        chartView: chartView,
        projectKey: projectKey,
        routeName: route.name,
        config: config,
        isBoardLocationless: isBoardLocationless,
        isReportsView: isReportsView
    };
};

});
parcelRegister("eZFkq", function(module, exports) {

$parcel$export(module.exports, "toCamelCaseChartView", () => $8f9b588eed549686$export$f1cb745981250009);
$parcel$export(module.exports, "getMode", () => $8f9b588eed549686$export$1fc0f6205829e19c);
$parcel$export(module.exports, "getModeV2", () => $8f9b588eed549686$export$cc65f5a30b63da10);

var $e4eHl = parcelRequire("e4eHl");

const $8f9b588eed549686$export$f1cb745981250009 = (chartView)=>(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(chartView);
const $8f9b588eed549686$export$1fc0f6205829e19c = (view)=>{
    switch(view){
        case 'planning':
        case 'planning.nodetail':
            return 0, $257789568f7508a4$export$c303e491e026ebc6;
        case 'reporting':
            return 0, $257789568f7508a4$export$e3d31417f21c1ce7;
        default:
            return 0, $257789568f7508a4$export$77d6f70978850641;
    }
};
const $8f9b588eed549686$export$cc65f5a30b63da10 = (routeName)=>{
    if (!routeName) return 0, $257789568f7508a4$export$77d6f70978850641;
    switch(routeName){
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
            return 0, $257789568f7508a4$export$c303e491e026ebc6;
        case 'rapidboard-report':
        case 'rapidboard-user-report':
            return 0, $257789568f7508a4$export$e3d31417f21c1ce7;
        default:
            return 0, $257789568f7508a4$export$77d6f70978850641;
    }
};

});
const $257789568f7508a4$export$77d6f70978850641 = 'work';
const $257789568f7508a4$export$c303e491e026ebc6 = 'plan';
const $257789568f7508a4$export$e3d31417f21c1ce7 = 'report';



parcelRegister("7waah", function(module, exports) {

$parcel$export(module.exports, "ProjectBreadcrumbs", () => $8abb6938d84ad6f7$export$38f8c59e2af08a87);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $koVbs = parcelRequire("koVbs");

var $4Fx92 = parcelRequire("4Fx92");
const $8abb6938d84ad6f7$export$38f8c59e2af08a87 = /*#__PURE__*/ (0, $5uXOq.memo)(({ baseUrl: baseUrl, boardId: boardId, boardName: boardName, projectKey: projectKey, projectName: projectName, projectId: projectId, isSimplifiedProject: isSimplifiedProject, chart: chart })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const reportsHref = (0, $4R6GH.fg)('reports-overview-page-migration') ? `/jira/software/c/projects/${projectKey}/boards/${boardId}/reports` : `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/software/c/projects/${projectKey}/boards/${boardId}`,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $4Fx92.messages).projectReportBreadcrumb),
            href: reportsHref
        }
    })));
});

});
parcelRegister("4Fx92", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5aafea47193ed555$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5aafea47193ed555$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.project.project-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("liUyW", function(module, exports) {

$parcel$export(module.exports, "UserBreadcrumbs", () => $3727e2d15103e5d8$export$74fdd5a0187b08ef);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $75PvK = parcelRequire("75PvK");

var $koVbs = parcelRequire("koVbs");

var $ikP65 = parcelRequire("ikP65");
const $3727e2d15103e5d8$export$74fdd5a0187b08ef = /*#__PURE__*/ (0, $5uXOq.memo)(({ accountId: accountId, boardId: boardId, boardName: boardName, profileUrl: profileUrl, userName: userName, chart: chart, isLocationlessBoard: isLocationlessBoard })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (isLocationlessBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75PvK.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&locationless=true`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $ikP65.messages).userReportBreadcrumb),
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&chart=${chart}&locationless=true`
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75PvK.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/people/${accountId}/boards/${boardId}`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $ikP65.messages).userReportBreadcrumb),
            href: `/jira/people/${accountId}/boards/${boardId}/reports/${chart}`
        }
    })));
});

});
parcelRegister("ikP65", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0a2e9bc5bc00af22$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0a2e9bc5bc00af22$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    userReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.user.user-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});



parcelRegister("1kij3", function(module, exports) {

$parcel$export(module.exports, "default", () => $284ba787b422c110$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $aaV7S = parcelRequire("aaV7S");

var $6BZYo = parcelRequire("6BZYo");

var $4R6GH = parcelRequire("4R6GH");

var $feJRr = parcelRequire("feJRr");

var $i8JTM = parcelRequire("i8JTM");

var $dPlT1 = parcelRequire("dPlT1");

var $dZw8H = parcelRequire("dZw8H");



const $284ba787b422c110$var$BacklogPage = (parcelRequire("aZRvq")).default;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $284ba787b422c110$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind?.('QuickCreateIssue.sessionComplete', callback);
    });
};
const $284ba787b422c110$var$isBoardSizeLimit = (planDataResponse)=>planDataResponse.isIssueLimitExceeded;
const $284ba787b422c110$var$BacklogApp = ({ rapidViewId: rapidViewId, projectKeyFromContext: projectKeyFromContext, projectIdFromContext: projectIdFromContext, tenantContext: tenantContext, data: data, planModeData: planModeData, planModeDataPromise: planModeDataPromise, cmpBacklogData: cmpBacklogData, cmpBacklogDataPromise: cmpBacklogDataPromise, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, error: error, loading: loading })=>{
    // We are assuming that if we get a 400 error, it's because the user doesn't have access to the project for whatever reason
    // including project being deleted that is linked to the board in which we'd prompt the user to change the board's location.
    if (!loading && error && error.message === (0, $a64d16806d35fb92$export$912d9029af46d426)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aaV7S.AsyncLocationlessDialog), {
        rapidViewId: rapidViewId
    });
    const shouldRenderSkeleton = (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? !cmpBacklogDataPromise : !planModeDataPromise;
    if (shouldRenderSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8JTM.NextGenBacklogSkeleton), null);
    if ((0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? cmpBacklogData && $284ba787b422c110$var$isBoardSizeLimit(cmpBacklogData.result) : planModeData && $284ba787b422c110$var$isBoardSizeLimit(planModeData)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPlT1.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feJRr.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($284ba787b422c110$var$BacklogPage, {
        key: (0, $4R6GH.fg)('remount_root_component_on_switching_backlog') ? String(rapidViewId) : undefined,
        isCacheHit: isCacheHit,
        bindToOnJiraGlobalIssueCreateClose: $284ba787b422c110$var$bindToOnJiraGlobalIssueCreateClose,
        // Route match data that could be read inside of the app
        projectKey: projectKeyFromContext,
        projectId: Number(projectIdFromContext),
        rapidViewId: String(rapidViewId),
        // Tenant context data that could be read inside of the app
        locale: tenantContext.locale,
        baseUrl: tenantContext.baseUrl,
        xsrfToken: tenantContext.xsrfToken ?? '',
        cloudId: tenantContext.cloudId ?? '',
        atlassianAccountId: tenantContext.atlassianAccountId ?? null,
        prefetchedData: data,
        prefetchedJiraPlanRestData: planModeData,
        prefetchedJiraPlanRestDataPromise: planModeDataPromise,
        prefetchCmpBacklogData: cmpBacklogData,
        prefetchCmpBacklogDataPromise: cmpBacklogDataPromise,
        isServer: false,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        isCompanyManaged: true,
        // TODO: This is wrong
        projectName: projectKeyFromContext
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
var $284ba787b422c110$export$2e2bcd8739ae039 = $284ba787b422c110$var$BacklogApp;

});
parcelRegister("aaV7S", function(module, exports) {

$parcel$export(module.exports, "AsyncLocationlessDialog", () => $5875e6aa9017967d$export$15ccbdebadffcb56);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// TODO: FEBA-214 - convert to use EntryPoint (see https://hello.atlassian.net/wiki/spaces/UAF/pages/2333138307/Tutorial+How+to+create+an+EntryPoint)
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5875e6aa9017967d$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("1JJWn")), {
    moduleId: "./src/packages/board-location-dialogs/locationless/src/app.tsx"
});
const $5875e6aa9017967d$export$15ccbdebadffcb56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-async-locationless-dialog",
        teamName: "a4t-pandora",
        packageName: "jiraBoardLocationDialogsLocationless"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "locationless-dialog-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5875e6aa9017967d$var$LazyComponent, {
        baseUrl: "",
        ...props
    })));

});
parcelRegister("1JJWn", function(module, exports) {

let $143da1428aa79e81$var$load = (parcelRequire("28QjX"))(4);
module.exports = $143da1428aa79e81$var$load("9DfZr").then(()=>parcelRequire('h6olf'));

});


parcelRegister("feJRr", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa35a5a19d0a4620$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $8Qrwl = parcelRequire("8Qrwl");
class $aa35a5a19d0a4620$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { name: name } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Qrwl.default).Consumer, null, ({ pageId: pageId, onCustomMark: onCustomMark })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
                op: onCustomMark,
                args: [
                    name,
                    pageId
                ]
            }));
    }
}

});

parcelRegister("i8JTM", function(module, exports) {

$parcel$export(module.exports, "NextGenBacklogSkeleton", () => $de21fa38a510bb6d$export$33cd465913cf178f);
/* NextGenBacklogSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $hCy6k = parcelRequire("hCy6k");

var $5Pi2v = parcelRequire("5Pi2v");
const $de21fa38a510bb6d$export$433c2e8574f2e911 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Pi2v)))
    });
const $de21fa38a510bb6d$export$88189b56881f213e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de21fa38a510bb6d$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Pi2v)))
    }));
const $de21fa38a510bb6d$var$BacklogSkeleton = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $de21fa38a510bb6d$export$88189b56881f213e, $de21fa38a510bb6d$export$433c2e8574f2e911);
const $de21fa38a510bb6d$export$33cd465913cf178f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", false ? {
        'data-ssr-placeholder': 'software-backlog-skeleton'
    } : {
        'data-ssr-placeholder-replace': 'software-backlog-skeleton'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de21fa38a510bb6d$var$BacklogSkeleton, null));
// Adding this wrapper to override the border width from AppSkeletonImage
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $de21fa38a510bb6d$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Pi2v", function(module, exports) {
module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();

});


parcelRegister("dPlT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f002878b2588702$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5Zxxp = parcelRequire("5Zxxp");

var $c8ARX = parcelRequire("c8ARX");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $doZTA = parcelRequire("doZTA");

var $5CRhS = parcelRequire("5CRhS");

var $1Lvdv = parcelRequire("1Lvdv");

var $3MT7z = parcelRequire("3MT7z");
const $0f002878b2588702$var$issueLimitsIPHArticleId = '1KMwTxMBNiDPhaHMDlfT4u';
/**
 * TODO: update primaryAction to redirect to board filter via savedFilterId
 * TODO: accommodate TMP empty states by copying existing version
 */ const $0f002878b2588702$var$SizeLimitError = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage } = (0, $5uXOq.useMemo)(()=>(0, $3MT7z.getIssueLimitMessages)(name), [
        name
    ]);
    const boardSettingsUrl = `${location.pathname}?config=filter`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default)),
        header: formatMessage(headerMessage),
        description: formatMessage(descriptionMessage),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: boardSettingsUrl,
            appearance: "primary"
        }, formatMessage((0, $5CRhS.default).editFilter)),
        tertiaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
            appearance: "link",
            articleId: $0f002878b2588702$var$issueLimitsIPHArticleId,
            fallbackComponent: null
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $5CRhS.default).moreLinkTextIssueTerminologyRefreshM4 : (0, $5CRhS.default).moreLinkText))
    });
};
const $0f002878b2588702$var$SizeLimitErrorEmptyState = ()=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const showErrorWithNoCTA = name === 'servicedesk-boards';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0f002878b2588702$var$containerStyles
    }, showErrorWithNoCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Lvdv.SizeLimitErrorWithNoCTA), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f002878b2588702$var$SizeLimitError, null));
};
const $0f002878b2588702$var$containerStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
var $0f002878b2588702$export$2e2bcd8739ae039 = $0f002878b2588702$var$SizeLimitErrorEmptyState;

});
parcelRegister("5Zxxp", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $b0d1b3c2fea05784$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $b0d1b3c2fea05784$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $hsmeR = parcelRequire("hsmeR");

var $6s1PB = parcelRequire("6s1PB");
const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $b0d1b3c2fea05784$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $4R6GH.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$export$5a09250ffddd7fd1;
const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
const $b0d1b3c2fea05784$var$buttonWrapperSubtleStyles = null;

});

parcelRegister("c8ARX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fefc6da4073af21$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mstqrh7gfrgxbc8ggp3w5jrj
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mstqrh7gfrgxbc8ggp3w5jrj

var $dCLgq = parcelRequire("dCLgq");

var $8e77Q = parcelRequire("8e77Q");
const $2fefc6da4073af21$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8e77Q)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8e77Q))
});
var $2fefc6da4073af21$export$2e2bcd8739ae039 = $2fefc6da4073af21$var$Illustration;
// for advanced use only
const $2fefc6da4073af21$export$a179c88182cb9d56 = [
    0,
    0,
    236,
    211
];

});
parcelRegister("8e77Q", function(module, exports) {
module.exports = new URL("loading-file-error.402df2c9.svg", import.meta.url).toString();

});


parcelRegister("iVgQf", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $7affac5c7e698fc8$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4Bpvs = parcelRequire("4Bpvs");
function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, $4Bpvs.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $lD23V.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $lD23V.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $bwpsq.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("4Bpvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $029e22a35a3f42f7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gZXfK")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("ieXL6")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $dCLgq = parcelRequire("dCLgq");

var $ieXL6 = parcelRequire("ieXL6");

var $gZXfK = parcelRequire("gZXfK");
const $029e22a35a3f42f7$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gZXfK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ieXL6))
});
var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
// for advanced use only
const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("ieXL6", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("gZXfK", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("5CRhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8501f4d49e03f39$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $d8501f4d49e03f39$var$messages = (0, $7VHMR.defineMessages)({
    boardHeader: {
        "id": "software-size-limit-error-empty-state.board-header",
        "defaultMessage": "Too many issues to display the board"
    },
    backlogHeader: {
        "id": "software-size-limit-error-empty-state.backlog-header",
        "defaultMessage": "Too many issues to display the backlog"
    },
    timelineHeader: {
        "id": "software-size-limit-error-empty-state.timeline-header",
        "defaultMessage": "Too many issues to display the timeline"
    },
    boardDescription: {
        "id": "software-size-limit-error-empty-state.board-description",
        "defaultMessage": "The board can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    backlogDescription: {
        "id": "software-size-limit-error-empty-state.backlog-description",
        "defaultMessage": "The backlog can only display up to 5,000 issues at a time. Move or delete issues to continue using your backlog."
    },
    timelineDescription: {
        "id": "software-size-limit-error-empty-state.timeline-description",
        "defaultMessage": "The timeline can only display up to 5,000 issues at a time. Move or delete issues to continue using your timeline."
    },
    editFilter: {
        "id": "software-size-limit-error-empty-state.edit-filter",
        "defaultMessage": "Edit filter"
    },
    moreLinkText: {
        "id": "software-size-limit-error-empty-state.more-link-text",
        "defaultMessage": "More about issue limits"
    },
    boardHeaderIssueTerminologyRefreshM4: {
        "id": "software-size-limit-error-empty-state.board-header-issue-terminology-refresh-m4",
        "defaultMessage": "Too many work items to display the board"
    },
    backlogHeaderIssueTerminologyRefreshM4: {
        "id": "software-size-limit-error-empty-state.backlog-header-issue-terminology-refresh-m4",
        "defaultMessage": "Too many work items to display the backlog"
    },
    timelineHeaderIssueTerminologyRefreshM4: {
        "id": "software-size-limit-error-empty-state.timeline-header-issue-terminology-refresh-m4",
        "defaultMessage": "Too many work items to display the timeline"
    },
    boardDescriptionIssueTerminologyRefreshM4: {
        "id": "software-size-limit-error-empty-state.board-description-issue-terminology-refresh-m4",
        "defaultMessage": "The board can only display up to 5,000 work items at a time. Move or delete work items to continue using your board."
    },
    backlogDescriptionIssueTerminologyRefreshM4: {
        "id": "software-size-limit-error-empty-state.backlog-description-issue-terminology-refresh-m4",
        "defaultMessage": "The backlog can only display up to 5,000 work items at a time. Move or delete work items to continue using your backlog."
    },
    timelineDescriptionIssueTerminologyRefreshM4: {
        "id": "software-size-limit-error-empty-state.timeline-description-issue-terminology-refresh-m4",
        "defaultMessage": "The timeline can only display up to 5,000 work items at a time. Move or delete work items to continue using your timeline."
    },
    moreLinkTextIssueTerminologyRefreshM4: {
        "id": "software-size-limit-error-empty-state.more-link-text-issue-terminology-refresh-m4",
        "defaultMessage": "More about work item limits"
    }
});
var $d8501f4d49e03f39$export$2e2bcd8739ae039 = $d8501f4d49e03f39$var$messages;

});

parcelRegister("1Lvdv", function(module, exports) {

$parcel$export(module.exports, "SizeLimitErrorWithNoCTA", () => $df14d8f608088d44$export$c0bbfc5b8cd7cce0);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $4R6GH = parcelRequire("4R6GH");

var $c8ARX = parcelRequire("c8ARX");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $enlND = parcelRequire("enlND");
const $df14d8f608088d44$export$c0bbfc5b8cd7cce0 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default)),
        header: formatMessage((0, $enlND.default).header),
        description: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $enlND.default).descriptionIssueTerminologyRefreshM4 : (0, $enlND.default).description)
    });
};

});
parcelRegister("enlND", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e7d6e770f65f431$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $9e7d6e770f65f431$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-size-limit-error-empty-state.size-limit-error-no-cta.header",
        "defaultMessage": "We couldn\u2019t load your board"
    },
    description: {
        "id": "software-size-limit-error-empty-state.size-limit-error-no-cta.description",
        "defaultMessage": "Boards only work in projects with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    },
    descriptionIssueTerminologyRefreshM4: {
        "id": "software-size-limit-error-empty-state.size-limit-error-no-cta.description-issue-terminology-refresh-m4",
        "defaultMessage": "Boards only work in projects with less than 5,000 work items. We\u2019re working on this and will let you know when it has changed."
    }
});
var $9e7d6e770f65f431$export$2e2bcd8739ae039 = $9e7d6e770f65f431$var$messages;

});


parcelRegister("3MT7z", function(module, exports) {

$parcel$export(module.exports, "getIssueLimitMessages", () => $75e0d55398e1041f$export$5c4dd481ffce3dbf);

var $4R6GH = parcelRequire("4R6GH");

var $5CRhS = parcelRequire("5CRhS");
const $75e0d55398e1041f$export$5c4dd481ffce3dbf = (routeName)=>{
    switch(routeName){
        case 'rapidboard-board':
        case 'rapidboard-user-board':
        case 'software-boards':
        case 'servicedesk-boards':
            return {
                headerMessage: (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $5CRhS.default).boardHeaderIssueTerminologyRefreshM4 : (0, $5CRhS.default).boardHeader,
                descriptionMessage: (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $5CRhS.default).boardDescriptionIssueTerminologyRefreshM4 : (0, $5CRhS.default).boardDescription
            };
        case 'software-timeline':
        case 'software-timeline-classic':
            return {
                headerMessage: (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $5CRhS.default).timelineHeaderIssueTerminologyRefreshM4 : (0, $5CRhS.default).timelineHeader,
                descriptionMessage: (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $5CRhS.default).timelineDescriptionIssueTerminologyRefreshM4 : (0, $5CRhS.default).timelineDescription
            };
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
        case 'software-backlog':
        default:
            return {
                headerMessage: (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $5CRhS.default).backlogHeaderIssueTerminologyRefreshM4 : (0, $5CRhS.default).backlogHeader,
                descriptionMessage: (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $5CRhS.default).backlogDescriptionIssueTerminologyRefreshM4 : (0, $5CRhS.default).backlogDescription
            };
    }
};

});


parcelRegister("aZRvq", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('jsw-backlog-main-component-refactor', function() {
    return parcelRequire('b12zb');
}, function() {
    return parcelRequire('76Weg');
});

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});




parcelRegister("bcP1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7bdb2feeca931f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $8Uumt = parcelRequire("8Uumt");

var $gEFwt = parcelRequire("gEFwt");

var $x9xyg = parcelRequire("x9xyg");

var $dXq4S = parcelRequire("dXq4S");

var $3mYHL = parcelRequire("3mYHL");

var $ao2h1 = parcelRequire("ao2h1");

var $jgtyX = parcelRequire("jgtyX");

var $bC0n0 = parcelRequire("bC0n0");

var $6DTBr = parcelRequire("6DTBr");

var $9SRRO = parcelRequire("9SRRO");

var $5uWNE = parcelRequire("5uWNE");

var $9dbF6 = parcelRequire("9dbF6");

var $9OXo1 = parcelRequire("9OXo1");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");
var $2YP9W = parcelRequire("2YP9W");

var $0z6W8 = parcelRequire("0z6W8");

var $6s1PB = parcelRequire("6s1PB");


var $ahuix = parcelRequire("ahuix");

var $83Pnu = parcelRequire("83Pnu");
const $a7bdb2feeca931f5$export$6a9f96b87df4de90 = ()=>{
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const [boardIdStr] = (0, $bmKPg.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$b5f697f1279a473e));
    });
    const backlogDataResource = (0, $2YP9W.useResource)((0, $bC0n0.backlogSyncResource));
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$a6940922387b16));
    });
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$e9163c48bfd4013e));
    }, ()=>!!backlogDataResource.data);
    let filterRefinementQueryRef;
    if ((0, $6s1PB.expVal)('filter_refinement_in_tmp_backlog', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $6DTBr.backlogFilterRefinementResource));
        filterRefinementQueryRef = queryReference;
    }
    const response = (0, $ao2h1.useRelayResource)((0, $9SRRO.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const isCacheHitRef = (0, $5uXOq.useRef)(backlogDataResource.data != null);
    const isCacheHit = isCacheHitRef.current;
    const { data: data, loading: loading, error: error } = backlogDataResource;
    const projectKeyFromContext = data?.boardScope.projectLocation.key || '';
    const projectNameFromContext = data?.boardScope.projectLocation.name || '';
    const projectIdFromContext = data?.boardScope.projectLocation.id || '';
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $8Uumt.useQueryLoader)((0, $jgtyX.default));
    (0, $5uXOq.useEffect)(()=>{
        // only run the query if projectId exists in context
        // we load the query client-side because:
        //  1. The field relies on projectId which isn't available from the URL path
        //  2. We don't want version data to block the critical page load
        if (loadVersionFilterRelayQuery != null && projectIdFromContext != null && projectIdFromContext.length > 0) {
            const jiraProjectId = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'project',
                resourceId: `${projectIdFromContext}`
            });
            loadVersionFilterRelayQuery({
                jiraProjectIds: [
                    jiraProjectId
                ],
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        projectIdFromContext,
        tenantContext.cloudId
    ]);
    const [selectedIssue] = (0, $ieDtd.useQueryParam)('selectedIssue');
    (0, $5uXOq.useEffect)(()=>{
        if (selectedIssue) (0, $0z6W8.updatePageloadName)('next-gen-backlog-with-issue-view');
    }, [
        selectedIssue
    ]);
    // redirect to the board only if the backlog is disabled, no redirect if timeout
    if (loading === false && (0, $ahuix.isBacklogDisabled)(data)) {
        const urlProjectKey = projectKey ?? projectKeyFromContext;
        const boardUrl = (0, $ahuix.getBoardUrl)(urlProjectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: boardUrl
        });
    }
    const backlogEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $83Pnu.default), {
        rapidViewId: boardId,
        projectKey: projectKey ?? projectKeyFromContext,
        projectKeyFromContext: projectKeyFromContext,
        projectNameFromContext: projectNameFromContext,
        projectIdFromContext: projectIdFromContext,
        tenantContext: tenantContext,
        data: data,
        error: error,
        loading: loading,
        isCacheHit: isCacheHit,
        customFiltersQueryRef: customFiltersQueryRef,
        backlogFilterRefinementQueryRef: filterRefinementQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uWNE.default), {
        resource: backlogDataResource,
        refreshOnExpired: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: tenantContext.baseUrl,
        projectKey: projectKeyFromContext,
        projectName: projectNameFromContext,
        projectId: projectIdFromContext,
        isSimplifiedProject: true
    }, backlogEl, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
        projectKey: projectKey ?? projectKeyFromContext ?? null
    }));
};
var $a7bdb2feeca931f5$export$2e2bcd8739ae039 = $a7bdb2feeca931f5$export$6a9f96b87df4de90;

});
parcelRegister("bC0n0", function(module, exports) {

$parcel$export(module.exports, "backlogSyncResource", () => $1f9e7587bfbf950c$export$ae26ed4881473ce4);

var $2M1hQ = parcelRequire("2M1hQ");


var $lq5RB = parcelRequire("lq5RB");
const $1f9e7587bfbf950c$export$ae26ed4881473ce4 = (0, $2M1hQ.createResource)({
    type: (0, $fe839261f35d1611$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>Promise.resolve({
            default: (0, $lq5RB.default)
        }),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("lq5RB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getEarlyPreload", () => $6ad6b3be334e1ef4$export$fed0052f40119df3);
$parcel$export(module.exports, "fetchData", () => $6ad6b3be334e1ef4$export$8134c072fddab6a5);
$parcel$export(module.exports, "default", () => $6ad6b3be334e1ef4$export$2e2bcd8739ae039);

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $74daz = parcelRequire("74daz");

var $cNrxd = parcelRequire("cNrxd");
const $6ad6b3be334e1ef4$export$fed0052f40119df3 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JSW_BACKLOG_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JSW_BACKLOG_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JSW_BACKLOG_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((preload)=>{
            if (preload.errors && preload.errors.length || !preload.data?.boardScope) throw new (0, $cNrxd.SwagError)({
                graphQLErrors: preload.errors,
                errorMessage: 'Backlog early fetch failed'
            });
            return preload.data;
        });
    }
    return null;
};
const $6ad6b3be334e1ef4$export$8134c072fddab6a5 = (baseUrl, rapidViewId)=>{
    const earlyPreload = $6ad6b3be334e1ef4$export$fed0052f40119df3();
    if (earlyPreload != null) return earlyPreload;
    const data = (0, $74daz.fetchAgilityGraphqlData)(baseUrl, rapidViewId);
    return data;
};
const $6ad6b3be334e1ef4$var$BACKLOG_FETCH_START_MARK = 'BACKLOG_FETCH_START';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ad6b3be334e1ef4$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const { baseUrl: baseUrl } = tenantContext;
    const rapidViewId = match.params.boardId || '';
    (0, $x9xyg.setMark)($6ad6b3be334e1ef4$var$BACKLOG_FETCH_START_MARK);
    try {
        setTimeout(()=>{
            (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        });
        const data = await $6ad6b3be334e1ef4$export$8134c072fddab6a5(baseUrl, rapidViewId);
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.next-gen.backlog.getData',
            message: 'An error was thrown while prefetching backlog data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("hXKq5", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $f6cddc52a08e036c$export$c8f0e9837e7e9425);

const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;

});


parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $2YZCu = parcelRequire("2YZCu");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("74daz", function(module, exports) {

$parcel$export(module.exports, "fetchAgilityGraphqlData", () => $8125f9503b9f63f0$export$bd0cd61988658475);
$parcel$export(module.exports, "default", () => $8125f9503b9f63f0$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cab1K = parcelRequire("cab1K");

var $2YZCu = parcelRequire("2YZCu");

var $cBLvH = parcelRequire("cBLvH");

var $7VysW = parcelRequire("7VysW");

var $drQql = parcelRequire("drQql");
const $8125f9503b9f63f0$var$BACKLOG = 'BACKLOG';
// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
const $8125f9503b9f63f0$var$CacheUpdateSubject = new (0, $cab1K.Subject)();
const $8125f9503b9f63f0$var$loadAgilityGraphqlData = (baseUrl, boardId)=>{
    const requestStartTime = new Date().valueOf();
    const query = (0, $drQql.getQuery)();
    (0, $7VysW.setBacklogFetchStart)();
    return (0, $cBLvH.query$)(baseUrl, (0, $drQql.backlogDataOperationName), query, {
        boardId: boardId
    }).flatMap((data)=>{
        const requestEndTime = new Date().valueOf();
        (0, $2YZCu.default).safeInfoWithoutCustomerData(`rest.swag.${(0, $drQql.backlogDataOperationName)}.success`, '', {
            time: requestEndTime - requestStartTime
        });
        // Everytime we fetch this data, we can use it to hydrate the BACKLOG resources-cache
        $8125f9503b9f63f0$var$CacheUpdateSubject.next({
            origin: $8125f9503b9f63f0$var$BACKLOG,
            payload: data
        });
        (0, $7VysW.setBacklogFetchStop)();
        return (0, $kVLXA.Observable).of(data);
    });
};
const $8125f9503b9f63f0$export$bd0cd61988658475 = (baseUrl, boardId)=>$8125f9503b9f63f0$var$loadAgilityGraphqlData(baseUrl, boardId).toPromise().then((response)=>response);
var $8125f9503b9f63f0$export$2e2bcd8739ae039 = $8125f9503b9f63f0$var$loadAgilityGraphqlData;

});
parcelRegister("cBLvH", function(module, exports) {

$parcel$export(module.exports, "query$", () => $b2e62d4903324e0d$export$a332dd84c3221bf2);

var $4nUsC = parcelRequire("4nUsC");
const $b2e62d4903324e0d$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("4nUsC", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $9d6dd91dc35e6aa9$export$cbc7c612df05bda);
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("inj9P");
parcelRequire("64ZAE");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $9XE6b = parcelRequire("9XE6b");

var $aZFhV = parcelRequire("aZFhV");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $dGrdR = parcelRequire("dGrdR");

var $2YZCu = parcelRequire("2YZCu");

var $kobfu = parcelRequire("kobfu");

var $487fd = parcelRequire("487fd");

var $fnyT4 = parcelRequire("fnyT4");

var $4tcSU = parcelRequire("4tcSU");

var $fjcgS = parcelRequire("fjcgS");

var $4R6GH = parcelRequire("4R6GH");

var $cNrxd = parcelRequire("cNrxd");

var $04zaL = parcelRequire("04zaL");
const $9d6dd91dc35e6aa9$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $9d6dd91dc35e6aa9$var$callSwag$ = ({ operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $4tcSU.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $2YZCu.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $487fd.default)(`/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $9d6dd91dc35e6aa9$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $fnyT4.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, $7Jxgt.v4)();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $dGrdR.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $kVLXA.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(retryError, [
                'statusCode'
            ], null);
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $kVLXA.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'name'
        ], null);
        const swagError = new (0, $cNrxd.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $kobfu.getErrorHash)(swagError);
        (0, $04zaL.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $kVLXA.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $04zaL.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                if (response.errors.length > 100) {
                    if ((0, $4R6GH.fg)('tnk_try_to_mitigate_unknown_backlog_errors')) {
                        const errorWithMaxStatusCode = response.errors.filter((error)=>error.extensions?.statusCode).reduce((currentMax, current)=>{
                            const currentStatusCode = Number((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(current, [
                                'extensions',
                                'statusCode'
                            ]));
                            const maxStatusCode = currentMax ? Number((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(currentMax, [
                                'extensions',
                                'statusCode'
                            ])) : 0;
                            return currentStatusCode > maxStatusCode ? current : currentMax;
                        }, null);
                        const statusCode = Number(errorWithMaxStatusCode?.extensions?.statusCode) || null;
                        let genericMessage = `Too many Errors in response for ${operationName} (${response.errors.length} errors)`;
                        if (errorWithMaxStatusCode) genericMessage += `. With highest status code error message of: "${errorWithMaxStatusCode.message}"`;
                        (0, $04zaL.logRestError)([
                            genericMessage
                        ], null, operationName, 'too-many-errors');
                        $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                        return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                            graphQLErrors: [
                                {
                                    message: genericMessage,
                                    path: [
                                        genericMessage
                                    ],
                                    extensions: {
                                        statusCode: statusCode,
                                        errorType: 'too-many-errors'
                                    }
                                }
                            ],
                            traceId: traceId
                        }));
                    }
                    const genericMessage = `Too many Errors in response for ${operationName}`;
                    (0, $04zaL.logRestError)([
                        genericMessage
                    ], null, operationName, 'too-many-errors');
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                    return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                        graphQLErrors: [
                            {
                                message: genericMessage,
                                path: [
                                    genericMessage
                                ],
                                extensions: {
                                    statusCode: null,
                                    errorType: 'too-many-errors'
                                }
                            }
                        ],
                        traceId: traceId
                    }));
                }
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $04zaL.logRestError)(path, statusCode, operationName, errorType);
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $04zaL.logRestParsingError)(e, operationName);
            $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $kVLXA.Observable).of(response.data);
    });
};

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)()))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});

parcelRegister("cNrxd", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $116bdf44a4142aa3$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $116bdf44a4142aa3$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $116bdf44a4142aa3$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $116bdf44a4142aa3$export$7d7253f3a1a7c031);

var $jJZqs = parcelRequire("jJZqs");
const $116bdf44a4142aa3$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $116bdf44a4142aa3$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage), this.graphQLErrors = [], this.networkError = null, // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $116bdf44a4142aa3$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $116bdf44a4142aa3$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $116bdf44a4142aa3$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $jJZqs.default);
const $116bdf44a4142aa3$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $116bdf44a4142aa3$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});

parcelRegister("04zaL", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $1590485f1b901936$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $1590485f1b901936$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $1590485f1b901936$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $1590485f1b901936$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $1590485f1b901936$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $1590485f1b901936$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $1590485f1b901936$export$3e50530825dee9d1);

var $2YZCu = parcelRequire("2YZCu");
const $1590485f1b901936$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $2YZCu.default).safeErrorWithoutCustomerData(type, m, params);
};
const $1590485f1b901936$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $1590485f1b901936$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$1590485f1b901936$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $1590485f1b901936$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $1590485f1b901936$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $1590485f1b901936$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $1590485f1b901936$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $1590485f1b901936$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $1590485f1b901936$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $1590485f1b901936$export$25d52be9f4671e9e = (error, queryName)=>{
    $1590485f1b901936$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $1590485f1b901936$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $2YZCu.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $1590485f1b901936$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $2YZCu.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});



parcelRegister("7VysW", function(module, exports) {

$parcel$export(module.exports, "setBacklogFetchStart", () => $27213b8f5a70f01f$export$98082f6cfce5fbfd);
$parcel$export(module.exports, "setBacklogFetchStop", () => $27213b8f5a70f01f$export$a14619e64801099);

var $jvua8 = parcelRequire("jvua8");
const $27213b8f5a70f01f$export$98082f6cfce5fbfd = ()=>{
    (0, $jvua8.backlogFetch).start();
};
const $27213b8f5a70f01f$export$a14619e64801099 = ()=>{
    (0, $jvua8.backlogFetch).stop();
};

});
parcelRegister("jvua8", function(module, exports) {

$parcel$export(module.exports, "backlogFetch", () => $3b06e90a3e705fa7$export$c37fad154e1f0a06);

var $dGrdR = parcelRequire("dGrdR");
const $3b06e90a3e705fa7$export$c37fad154e1f0a06 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.data-fetch'
});

});


parcelRegister("drQql", function(module, exports) {

$parcel$export(module.exports, "backlogDataOperationName", () => $099f828ded21ecfb$export$2aa160b066ef4bbe);
$parcel$export(module.exports, "getQuery", () => $099f828ded21ecfb$export$71eec30d9db46a56);
/*!
 * ATTENTION
 *
 * This module is used on both the main backlog app and its vendorless early-script entry.
 *
 * Because of this, it can't have dependencies. Feature-flagging logic should be done outside this
 * module and values should be passed in. For now changes must happen on both calls.
 */ const $099f828ded21ecfb$export$2aa160b066ef4bbe = 'BacklogDataQuery';
const $099f828ded21ecfb$export$71eec30d9db46a56 = ()=>`
    query ${$099f828ded21ecfb$export$2aa160b066ef4bbe} ($boardId: ID!) {
        jira {
            timeTrackingOptions {
                workingHoursPerDay
                workingDaysPerWeek
                defaultUnit
                timeFormat
            }
        }
        boardScope(boardId: $boardId) {
            sprints(state:[ACTIVE, FUTURE]) {
                id
                name
                goal
                startDate
                endDate
                daysRemaining
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                sprintState
            }
            backlog {
                boardIssueListKey
                requestColumnMigration
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
            }
            board {
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                rankCustomFieldId
                issueParents {
                    id
                    key
                    summary
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
            }
            currentUser {
                permissions
            }
            projectLocation {
                id
                key
                name
                issueTypes {
                    id
                    name
                    iconUrl
                    hierarchyLevelType
                    hasRequiredFields
                }
                features {
                    key
                    status
                }
            }
            features {
                key
                status
            }
            estimation {
                current {
                    customFieldId
                }
                available {
                    statisticFieldId
                }
            }
        }
    }
`;

});




parcelRegister("6DTBr", function(module, exports) {

$parcel$export(module.exports, "backlogFilterRefinementResource", () => $da5207290785304f$export$f9d71cb27b4dd1d8);

var $gNStA = parcelRequire("gNStA");

var $ao2h1 = parcelRequire("ao2h1");

var $6s1PB = parcelRequire("6s1PB");

var $dXq4S = parcelRequire("dXq4S");

var $5T5EE = parcelRequire("5T5EE");

const $da5207290785304f$export$f9d71cb27b4dd1d8 = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('filter_refinement_in_tmp_backlog', 'isEnabled', false), (0, $ao2h1.createRelayResource)({
    type: (0, $fe839261f35d1611$export$214238a9ff4636a),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $5T5EE.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
}));

});
parcelRegister("5T5EE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2d4cd0ca7ffbade$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f792f8e7dc037abcb427c6104481635b>>
 * @relayHash 1380d721b18915720bbca11b40e27b39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fff74428c768ff9ead961fcc85650bd1e66c4e039411390b08d38d160e9ec27d
const $e2d4cd0ca7ffbade$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fff74428c768ff9ead961fcc85650bd1e66c4e039411390b08d38d160e9ec27d",
        "metadata": {},
        "name": "backlogFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e2d4cd0ca7ffbade$export$2e2bcd8739ae039 = $e2d4cd0ca7ffbade$var$node;

});


parcelRegister("83Pnu", function(module, exports) {

$parcel$export(module.exports, "default", () => $82700b5c274863dd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $6BZYo = parcelRequire("6BZYo");

var $feJRr = parcelRequire("feJRr");

var $i8JTM = parcelRequire("i8JTM");

var $gFU0Q = parcelRequire("gFU0Q");

var $5sgUt = parcelRequire("5sgUt");

var $7LEyz = parcelRequire("7LEyz");

var $dZw8H = parcelRequire("dZw8H");

var $4R6GH = parcelRequire("4R6GH");


const $82700b5c274863dd$var$BacklogPage = (parcelRequire("aZRvq")).default;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $82700b5c274863dd$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind?.('QuickCreateIssue.sessionComplete', callback);
    });
};
const $82700b5c274863dd$var$BacklogApp = ({ rapidViewId: rapidViewId, projectKey: projectKey, projectKeyFromContext: projectKeyFromContext, projectIdFromContext: projectIdFromContext, projectNameFromContext: projectNameFromContext, tenantContext: tenantContext, data: data, error: error, loading: loading, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, backlogFilterRefinementQueryRef: backlogFilterRefinementQueryRef })=>{
    const isAppReady = Boolean(data);
    if ((0, $5sgUt.isBoardSizeLimitError)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LEyz.default), {
        projectKey: projectKey
    });
    if (error && !loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFU0Q.BacklogSlaTracker), {
        error: error
    });
    if (!isAppReady) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8JTM.NextGenBacklogSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feJRr.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82700b5c274863dd$var$BacklogPage, {
        key: (0, $4R6GH.fg)('remount_root_component_on_switching_backlog') ? String(rapidViewId) : undefined,
        isCacheHit: isCacheHit,
        bindToOnJiraGlobalIssueCreateClose: $82700b5c274863dd$var$bindToOnJiraGlobalIssueCreateClose,
        // Route match data that could be read inside of the app
        projectKey: projectKeyFromContext,
        projectId: Number(projectIdFromContext),
        projectName: projectNameFromContext,
        rapidViewId: String(rapidViewId),
        // Tenant context data that could be read inside of the app
        locale: tenantContext.locale,
        baseUrl: tenantContext.baseUrl,
        xsrfToken: tenantContext.xsrfToken ?? '',
        cloudId: tenantContext.cloudId ?? '',
        atlassianAccountId: tenantContext.atlassianAccountId ?? null,
        prefetchedData: data,
        isServer: false,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        backlogFilterRefinementQueryRef: backlogFilterRefinementQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
var $82700b5c274863dd$export$2e2bcd8739ae039 = $82700b5c274863dd$var$BacklogApp;

});
parcelRegister("gFU0Q", function(module, exports) {

$parcel$export(module.exports, "BacklogSlaTracker", () => $361995e08400e282$export$a34f0231312fddfc);
$parcel$export(module.exports, "CmpBacklogSlaTracker", () => $361995e08400e282$export$836eecf117869739);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $4R6GH = parcelRequire("4R6GH");

var $5Nutl = parcelRequire("5Nutl");

var $01j5n = parcelRequire("01j5n");

var $2YP9W = parcelRequire("2YP9W");

const $361995e08400e282$export$a34f0231312fddfc = ({ error: error, location: location })=>{
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $01j5n.default)(error, location ?? (0, $a9c483c0d986286a$export$b6e4306772e8a60d)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: location ?? 'next-gen-backlog',
        error: error
    }));
    // return null when no errors
    return null;
};
const $361995e08400e282$export$836eecf117869739 = ()=>{
    const backlogData = (0, $2YP9W.useResource)((0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? (0, $5Nutl.uifBacklogResource) : (0, $5Nutl.uifBacklogResourceOld));
    const hasFired = (0, $5uXOq.useRef)(false);
    if (hasFired.current || !backlogData || !backlogData.error || backlogData.data || backlogData.loading) return null;
    hasFired.current = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($361995e08400e282$export$a34f0231312fddfc, {
        error: backlogData?.error,
        location: (0, $a9c483c0d986286a$export$7858b0b4e02abd78)
    });
};

});
parcelRegister("01j5n", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $5ca31bd2f34603ab$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "isClientSideThirdPartyAppError", () => $5ca31bd2f34603ab$export$ed0f33c09abc69f3);
$parcel$export(module.exports, "isFailureStatusCode", () => $5ca31bd2f34603ab$export$790c76b8c83c3421);
$parcel$export(module.exports, "default", () => $5ca31bd2f34603ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $g0Gtc = parcelRequire("g0Gtc");

var $2YZCu = parcelRequire("2YZCu");

var $kobfu = parcelRequire("kobfu");

var $fZneA = parcelRequire("fZneA");

var $7tQej = parcelRequire("7tQej");

var $4R6GH = parcelRequire("4R6GH");

var $hdE8g = parcelRequire("hdE8g");

var $3vXOY = parcelRequire("3vXOY");

var $e2KRD = parcelRequire("e2KRD");

const $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus = ({ location: location, statusCode: statusCode, traceId: traceId, hash: hash, buildKey: buildKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReasonWithStatusCode)((0, $3e83829bdc9c581d$export$a3bb34ea5a520df8), statusCode),
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
const $5ca31bd2f34603ab$export$34bc86f6bf17f1e0 = (error)=>{
    const networkErrorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'name'
    ], null);
    const networkErrorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'statusCode'
    ], null);
    if (networkErrorName && !networkErrorStatusCode) (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.network.error.unknown.error.name', networkErrorName);
    // A fetch() promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side,
    // although this usually means permission issues or similar — a 404 does not constitute a network error
    // more https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
    return networkErrorName === 'TypeError' || networkErrorName === 'AbortError';
};
const $5ca31bd2f34603ab$export$8a5d666d6e5b82fc = (error)=>{
    if (error?.name === 'ChunkLoadError') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.chunk.load.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$export$7193151b5738a995 = (error)=>{
    if (error?.name === 'ResponseNullError') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.response.null.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS = [
    'FPClassifier is not defined'
];
const $5ca31bd2f34603ab$var$KNOWN_REACT_PERFORMANCE_ERRORS = [
    'Maximum update depth exceeded',
    'Minified React error #185'
];
const $5ca31bd2f34603ab$export$ed0f33c09abc69f3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error.message) && !!$5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $5ca31bd2f34603ab$export$d6897bdd9fc569e3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error.message) && !!$5ca31bd2f34603ab$var$KNOWN_REACT_PERFORMANCE_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $5ca31bd2f34603ab$export$790c76b8c83c3421 = (statusCode)=>{
    if (statusCode == null || statusCode === 429 || statusCode >= 500) // jira is too busy, unknown error or server error
    return true;
    if (statusCode >= 400 && statusCode < 500) return false;
    return true;
};
const $5ca31bd2f34603ab$var$detectLocalNetworkErrors = (errorResponse)=>{
    if ($5ca31bd2f34603ab$export$34bc86f6bf17f1e0(errorResponse)) return 0, $3e83829bdc9c581d$export$3c39b2049cd1acb3;
    if ($5ca31bd2f34603ab$export$8a5d666d6e5b82fc(errorResponse)) return 0, $3e83829bdc9c581d$export$fdfe3175a0c7be80;
    if ((0, $fZneA.isClientFetchError)(errorResponse)) return 0, $3e83829bdc9c581d$export$38fe4329f59f7ac5;
    if ($5ca31bd2f34603ab$export$7193151b5738a995(errorResponse)) return 0, $3e83829bdc9c581d$export$49d11848b43d6dbf;
    if ($5ca31bd2f34603ab$export$ed0f33c09abc69f3(errorResponse)) return 0, $3e83829bdc9c581d$export$32e56551129a1642;
    if ($5ca31bd2f34603ab$export$d6897bdd9fc569e3(errorResponse) && (0, $4R6GH.fg)('tnk-ignore-react-performance-error-for-slo')) return 0, $3e83829bdc9c581d$export$23146e1063f522c4;
    return null;
};
const $5ca31bd2f34603ab$var$responseToSla = (errorResponse, location)=>{
    const statusCode = (0, $3vXOY.extractStatusCode)(errorResponse);
    const abortFailureReason = $5ca31bd2f34603ab$var$detectLocalNetworkErrors(errorResponse);
    const traceId = (0, $hdE8g.extractTraceId)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const hash = (0, $kobfu.getErrorHash)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const buildKey = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(window, [
        'BUILD_KEY'
    ]) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const errorResponseMessage = errorResponse?.message || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const isAbortReactPerformanceError = abortFailureReason === (0, $3e83829bdc9c581d$export$23146e1063f522c4);
    const isBacklogLocation = location === 'ng-backlog' || location === 'cmp-backlog';
    if (abortFailureReason && (!isAbortReactPerformanceError || isAbortReactPerformanceError && isBacklogLocation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)(abortFailureReason),
            error: errorResponseMessage,
            statusCode: statusCode || '',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === null) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.unknown.failure', (0, $3e83829bdc9c581d$export$b4f05a271d0831dc), {
            networkErrorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'name'
            ], ''),
            networkStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'statusCode'
            ], ''),
            graphqlStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'graphQLErrors',
                0,
                'extensions',
                'statusCode'
            ], ''),
            location: location,
            error: JSON.stringify(errorResponse, Object.getOwnPropertyNames(errorResponse)),
            hash: hash
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$b4f05a271d0831dc)),
                traceId: traceId,
                buildKey: buildKey,
                error: JSON.stringify({
                    message: errorResponseMessage
                }),
                hash: hash
            }
        });
    }
    // based on https://hello.atlassian.net/wiki/spaces/agile/pages/512782292/SWAG+response+handling+on+the+client
    // `EXPERIENCE_TRACKER_LOCATION_BACKLOG`, defined in `src/packages/software/backlog/src/common/constants/analytics.tsx`
    if (location === 'ng-backlog') {
        if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$c4493605407b2630)),
                error: errorResponseMessage,
                statusCode: statusCode.toString(),
                buildKey: buildKey,
                traceId: traceId,
                hash: hash
            }
        });
    }
    if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode === 429) // jira is too busy
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$7b9f56c34c008ec2)),
            error: errorResponseMessage,
            statusCode: '429',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === 404) // redirect to "all-projects" page or error page, when page is not found
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/software/projects/not-found"
    });
    if (statusCode > 400 && statusCode < 500) // the rest of 40X
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode >= 500) return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
    return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
};
var $5ca31bd2f34603ab$export$2e2bcd8739ae039 = $5ca31bd2f34603ab$var$responseToSla;

});
parcelRegister("hdE8g", function(module, exports) {

$parcel$export(module.exports, "extractTraceId", () => $6db1ddf832c04f2d$export$431eacb6aecbacdf);
const $6db1ddf832c04f2d$export$431eacb6aecbacdf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>String(error?.traceId || error?.networkError?.traceId || '');

});

parcelRegister("3vXOY", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeFromGraphQLErrors", () => $47b135a1579c5003$export$37c7f88726f3fb5e);
$parcel$export(module.exports, "extractStatusCode", () => $47b135a1579c5003$export$1fdf7c1c0741a7e7);

var $9XE6b = parcelRequire("9XE6b");

var $fEeCa = parcelRequire("fEeCa");
const $47b135a1579c5003$export$37c7f88726f3fb5e = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($fEeCa)))(statusCodes);
    return statusCode || null;
};
const $47b135a1579c5003$export$1fdf7c1c0741a7e7 = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
        'statusCode'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $47b135a1579c5003$export$37c7f88726f3fb5e(graphQLErrors);
    return null;
};

});
parcelRegister("fEeCa", function(module, exports) {

var $la2vn = parcelRequire("la2vn");

var $5JMmU = parcelRequire("5JMmU");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $b645ed9a7ba1767e$var$max(array) {
    return array && array.length ? $la2vn(array, $etyzk, $5JMmU) : undefined;
}
module.exports = $b645ed9a7ba1767e$var$max;

});
parcelRegister("la2vn", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $f67c7999c5b61dcb$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$4faK3(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $f67c7999c5b61dcb$var$baseExtremum;

});

parcelRegister("5JMmU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $42d6acb577163acc$var$baseGt(value, other) {
    return value > other;
}
module.exports = $42d6acb577163acc$var$baseGt;

});



parcelRegister("e2KRD", function(module, exports) {

$parcel$export(module.exports, "createFailureReason", () => $360af9265ac477eb$export$b9e48ed6f1b092c7);
$parcel$export(module.exports, "createFailureReasonWithStatusCode", () => $360af9265ac477eb$export$cc7dce678df87fe9);
const $360af9265ac477eb$export$b9e48ed6f1b092c7 = (reason)=>({
        failureReason: reason,
        errorMessage: reason
    });
const $360af9265ac477eb$export$cc7dce678df87fe9 = (reason, statusCode)=>{
    if (statusCode === undefined || statusCode === null) return {
        failureReason: reason,
        statusCode: '[unknown]',
        errorMessage: `${reason}-unknown`
    };
    return {
        failureReason: reason,
        statusCode: `${statusCode}`,
        errorMessage: `${reason}-${statusCode}`
    };
};

});

const $3e83829bdc9c581d$export$b4f05a271d0831dc = 'critical-data-failed-unknown-reason';
const $3e83829bdc9c581d$export$a3bb34ea5a520df8 = 'critical-data-failed-with-status-code';
const $3e83829bdc9c581d$export$7b9f56c34c008ec2 = '429-error';
const $3e83829bdc9c581d$export$c4493605407b2630 = 'client-error';
const $3e83829bdc9c581d$export$23146e1063f522c4 = 'react-performance-error';
const $3e83829bdc9c581d$export$3c39b2049cd1acb3 = 'user-network-error';
const $3e83829bdc9c581d$export$fdfe3175a0c7be80 = 'chunk-load-error';
const $3e83829bdc9c581d$export$38fe4329f59f7ac5 = 'client-fetch-error';
const $3e83829bdc9c581d$export$49d11848b43d6dbf = 'response-null-error';
const $3e83829bdc9c581d$export$32e56551129a1642 = 'client-third-party-app-error';
const $3e83829bdc9c581d$export$fa14a20fcf1b1eb4 = 'unknown';


const $a9c483c0d986286a$export$dfd208682d29484c = 'software-backlog';
const $a9c483c0d986286a$export$b6e4306772e8a60d = 'ng-backlog';
const $a9c483c0d986286a$export$7858b0b4e02abd78 = 'cmp-backlog';
const $a9c483c0d986286a$export$840e3848643f7781 = 'backlog';
const $a9c483c0d986286a$export$9f54a1518145e351 = 'Kanban';
const $a9c483c0d986286a$export$8ee1fad10cc70eb5 = 'Scrum';
const $a9c483c0d986286a$export$9a2b21d55c0f061c = 'Agility';


parcelRegister("5sgUt", function(module, exports) {

$parcel$export(module.exports, "isBoardSizeLimitError", () => $9689f51629af798e$export$c72e0becab2a28fe);

var $9XE6b = parcelRequire("9XE6b");
const $9689f51629af798e$export$c72e0becab2a28fe = (error)=>error != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    Array.isArray(error.graphQLErrors) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors[0] != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error.graphQLErrors[0], [
        'extensions',
        'statusCode'
    ]) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error.graphQLErrors[0], [
        'extensions',
        'errorType'
    ]) === 'jsw.board-size-limit-exceeded';

});

parcelRegister("7LEyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ba20431946ab6e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $5QVhk = parcelRequire("5QVhk");
/**
 * @deprecated use generic version of SizeLimitErrorEmptyStateComponent component @atlassian/jira-software-size-limit-error-empty-state
 */ const $85ba20431946ab6e$var$BoardSizeLimitErrorEmptyStateWithBaseUrl = ({ projectKey: projectKey, savedFilterId: savedFilterId, isCMPBoard: isCMPBoard = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QVhk.default), {
            projectKey: projectKey,
            baseUrl: baseUrl,
            isCMPBoard: isCMPBoard,
            savedFilterId: savedFilterId
        });
    });
var $85ba20431946ab6e$export$2e2bcd8739ae039 = $85ba20431946ab6e$var$BoardSizeLimitErrorEmptyStateWithBaseUrl;

});
parcelRegister("5QVhk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d46e677f9d568066$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $7Xi9S = parcelRequire("7Xi9S");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $6jY6G = parcelRequire("6jY6G");

var $bMyyL = parcelRequire("bMyyL");

var $gzib5 = parcelRequire("gzib5");
const $d46e677f9d568066$var$BoardSizeLimitError = ({ intl: intl, projectKey: projectKey, isCMPBoard: isCMPBoard = false, savedFilterId: savedFilterId })=>{
    const description = isCMPBoard ? intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).descriptionCmpIssueTermRefresh : (0, $bMyyL.default).descriptionCmp) : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).descriptionIssueTermRefresh : (0, $bMyyL.default).description);
    const url = isCMPBoard && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(savedFilterId) ? `/issues/?filter=${savedFilterId}` : `/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`;
    const buttonText = isCMPBoard ? intl.formatMessage((0, $bMyyL.default).editBoardFilter) : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).goToSearchIssueTermRefresh : (0, $bMyyL.default).goToSearch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7Xi9S))),
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).headerIssueTermRefresh : (0, $bMyyL.default).header),
        description: description,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: url,
            appearance: "primary"
        }, buttonText)
    }));
};
const $d46e677f9d568066$var$BoardSizeLimitErrorEmptyState = (props)=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const showErrorWithNoCTA = name === 'servicedesk-boards';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$Container, null, showErrorWithNoCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzib5.BoardSizeLimitErrorWithNoCTA), {
        intl: props.intl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$BoardSizeLimitError, props));
};
const $d46e677f9d568066$var$BoardSizeLimitErrorEmptyStateWithIntl = (0, $az4zD.injectIntlV2)($d46e677f9d568066$var$BoardSizeLimitErrorEmptyState);
var $d46e677f9d568066$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d46e677f9d568066$var$BoardSizeLimitErrorEmptyStateWithIntl;
const $d46e677f9d568066$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7Xi9S", function(module, exports) {
module.exports = new URL("something-wrong.1260804e.svg", import.meta.url).toString();

});

parcelRegister("bMyyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfedbe69eb72a9f4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $dfedbe69eb72a9f4$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.header",
        "defaultMessage": "Your board has too many issues"
    },
    goToSearch: {
        "id": "software-board-size-limit-error-empty-state.go-to-search",
        "defaultMessage": "See issues in search"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.description",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    descriptionCmp: {
        "id": "software-board-size-limit-error-empty-state.description-cmp",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Try editing your board's filter query to include fewer issues, or create an additional board."
    },
    editBoardFilter: {
        "id": "software-board-size-limit-error-empty-state.edit-board-filter",
        "defaultMessage": "Edit board filter"
    },
    headerIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.header-issue-term-refresh",
        "defaultMessage": "Your board has too many work items"
    },
    goToSearchIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.go-to-search-issue-term-refresh",
        "defaultMessage": "View everything in search"
    },
    descriptionIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.description-issue-term-refresh",
        "defaultMessage": "Boards can only display up to 5,000 work items at a time. Move or delete work to continue using your board."
    },
    descriptionCmpIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.description-cmp-issue-term-refresh",
        "defaultMessage": "Boards can only display up to 5,000 work items at a time. Try editing your board's filter query to include fewer work items, or create an additional board."
    }
});
var $dfedbe69eb72a9f4$export$2e2bcd8739ae039 = $dfedbe69eb72a9f4$var$messages;

});

parcelRegister("gzib5", function(module, exports) {

$parcel$export(module.exports, "BoardSizeLimitErrorWithNoCTA", () => $6e3be43d7f71b8ae$export$67ed49fd05b7aff8);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7Xi9S = parcelRequire("7Xi9S");

var $6s1PB = parcelRequire("6s1PB");

var $9NE02 = parcelRequire("9NE02");
const $6e3be43d7f71b8ae$export$67ed49fd05b7aff8 = ({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6e3be43d7f71b8ae$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7Xi9S))),
        header: intl.formatMessage((0, $9NE02.default).header),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9NE02.default).descriptionIssueTermRefresh : (0, $9NE02.default).description)
    }));
const $6e3be43d7f71b8ae$var$containerStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("9NE02", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e962dff92e62d1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a9e962dff92e62d1$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.header",
        "defaultMessage": "We couldn\u2019t load your board"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.description",
        "defaultMessage": "Boards only works in project with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    },
    descriptionIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.description-issue-term-refresh",
        "defaultMessage": "Boards only works in project with less than 5,000 work items. We\u2019re working on this and will let you know when it has changed."
    }
});
var $a9e962dff92e62d1$export$2e2bcd8739ae039 = $a9e962dff92e62d1$var$messages;

});










$parcel$global.rlb("ghmPk")
//# sourceMappingURL=async-next-gen-backlog.4031f54c.js.map
